import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconicModule } from '../iconic/iconic.module';
import { ListModule } from '../list/list.module';
import { RadioGroupComponent, RadioGroupItemTemplate } from './radio-group.component';

@NgModule({
  imports: [CommonModule, ListModule, IconicModule],
  declarations: [RadioGroupComponent, RadioGroupItemTemplate],
  exports: [RadioGroupComponent, RadioGroupItemTemplate],
})
export class RadioGroupModule {}
